<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    ModalYN(:config="configModal" @padre:close="selectNewOffice" v-show="modalStatus")
    ModalDocumentos(v-show="modalStatusD" :asignacion="prestamoToModal" @padre:close="cerrarModalD" @subirDocumento="subirDocumento" @borrarDocumento="borrarDocumento")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.has-text-centered
            h1.title {{ title }}
              | &nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
            br
        .columns
          .column.is-5(v-show="!userNormal")
            input#allH.is-checkradio.is-black(type='radio', value='ALL' v-model='query' checked='checked')
            label.is-size-6(for='allH') Todos
            input#tpaH.is-checkradio.is-black(type='radio', value='TPA' v-model='query')
            label.is-size-6(for='tpaH') TPA
            input#irgeH.is-checkradio.is-black(type='radio', value='IRGE' v-model='query')
            label.is-size-6(for='irgeH') IRGE
            input#corpH.is-checkradio.is-black(type='radio', value='CORP' v-model='query' v-show="areaAsignacion !== 'i'")
            label.is-size-6(for='corpH' v-show="areaAsignacion !== 'i'") CORP.
            input#ductoH.is-checkradio.is-black(type='radio', value='DUCTO' v-model='query')
            label.is-size-6(for='ductoH') DUCTO
          .column.is-4
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar por serie | recibe | ubicación | entrega',
                  v-model="query_articulos",
                )
          .column.is-3(:class="userNormal ? 'is-offset-6' : ''")
            a.button.is-success(@click="descargarResguardos") 
              i.fas.fa-download
              | &nbsp Excel
            | &nbsp
            a.button.is-black(@click="irSalidas('p')")
              i.fas.fa-plus
              | &nbsp Nuevo Préstamo
        .columns(v-show="result_query != ''")
          .column.is-offset-8.is-4
            span.tag.is-black.is-small {{ result_query }}
        .columns(v-show="hayDatos")
          .column
            .table-responsive
              table#tbPrestamos.table.is-striped.is-fullwidth
                thead
                  tr
                    th idSAP
                    th TAG
                    th Usuario
                    th Descripción
                    th Fecha Entrega
                    th Fecha Reingreso
                    th Ubic. del Préstamo
                tbody
                  tr(v-for="(data, index) in prestamosSelect" :key="data.id")
                    td 
                      a.button.is-black.is-rounded.is-small(@click="irPrestamoDetalle(data)") {{ data.idSAP === ''? 's/idSAP' : data.idSAP }} 
                    td 
                      span.tag.is-black(v-show="data.tag !== ''")
                        | {{ data.tag }}
                    td
                      a.button.is-rounded.is-small(@click="irResguardos(data.id_recibe)")
                        | {{ data.recibe }}
                      a.button.is-small.is-rounded(@click="firmar(data, 'E')" :class="data.firma_entrega==='' ? 'is-warning' : 'is-success' " v-show='verFirmar')
                        i.fas.fa-signature
                      | &nbsp
                      a.button.is-small.is-rounded(@click="firmar(data, 'R')" :class="data.firma_recibe==='' ? 'is-warning' : 'is-success' " v-show='verFirmar')
                        i.fas.fa-signature
                    td
                      span.tag.is-dark
                        | {{ data.descripcion.length > 30 ? `${data.descripcion.substring(0,30)}...` : data.descripcion }}
                      a.button.is-light.is-rounded.is-small(@click="verHistoria(data.id_articulo)")
                        i.fas.fa-history
                      | &nbsp
                      a.button.is-danger.is-rounded.is-small(@click="printReporte(data)")
                        i.fas.fa-file-pdf
                      br
                      span.tag.is-dark.is-small(v-show=" data.marca !== ''") Marca: {{ data.marca }} &nbsp&nbsp
                      span.tag.is-small(v-show=" data.modelo !== ''") Modelo: {{ data.modelo }} &nbsp&nbsp
                      span.tag.is-small(v-show=" data.serie !== ''") Serie: {{ data.serie }}
                      br
                      
                    td
                      span.tag.is-black
                        | {{ data.fecha_entrega }}
                    td
                      span.tag(:class="data.fecha_reingreso !== '' ? 'is-success' : 'is-warning'")
                        | {{ data.fecha_reingreso !== '' ? data.fecha_reingreso : 'Aún con usuario' }}
                    td
                      .control
                        .tags.has-addons
                          span.tag.is-dark
                            i.fas.fa-map-pin
                            | &nbsp {{ data.ubicacionArt }}
                          span.tag.is-primary
                            | {{ data.nombre_oficina }}
        .columns(v-show="!hayDatos")
          .column.is-4.is-offset-4
            .notification.is-danger No existen Registros aún en la Base de Datos.
        .columns.column-blanco
</template>

<script>
import Loader from '../shared/Loader.vue'
import NavBarInventario from './layout/NavBarInventario.vue'
import InventarioServices from '../../services/inventario/inventario'
import ModalYN from '@/components/shared/ModalYN.vue'
import ModalDocumentos from './shared/ModalDocumentos.vue'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'prestamos',
  components: { Loader, NavBarInventario, ModalYN, ModalDocumentos },
  data () {
    return {
      isLoading: true,
      prestamos: [],
      prestamosSelect: [],
      hayDatos: false,
      tipos: [],
      query_articulos: '',
      query: 'ALL',
      userNormal: false,
      itemCambiar: {},
      configModal: {},
      modalStatus: false,
      verArticulosArea: false,
      result_query: '',
      verFirmar: false,
      title: '',
      modalStatusD: false,
      prestamoToModal: {},
      sede: '',
      almacenes: [],
      origen: {},
      oficinas: [],
      ubicaciones: [
        { id: '1566247215482', nombre: 'IRGE', valor: 'IRGE' },
        { id: '1565899419222', nombre: 'TPA', valor: 'TPA' },
        { id: '1588283398540', nombre: 'CORPORATIVO', valor: 'CORP' },
        { id: '1566322725551', nombre: 'EB04', valor: 'EB04' },
        { id: '1588173714497', nombre: 'DUCTO', valor: 'LPGD' },
        { id: '1565964784014', nombre: 'EB00', valor: 'EB00' },
        { id: '1566330159028', nombre: 'EB01', valor: 'EB01' },
        { id: '1566235785478', nombre: 'EB02', valor: 'EB02' },
        { id: '1566338236531', nombre: 'EB03', valor: 'EB03' },
        { id: '1588172064431', nombre: 'ERM-TLAUTLA', valor: 'ERM' }
      ],
    }
  },
  watch: {
    query () {
      if (this.query !== '') {
        console.log('filter')
        if (this.query === 'ALL') {
          this.prestamosSelect = this.prestamos
        } else {
          let prestFilter = []
          switch (this.query) {
            case 'DUCTO':
              prestFilter = this.prestamos.filter( (prest) => prest.destino === 'EB00' || prest.destino === 'EB01' || prest.destino === 'EB02' || prest.destino === 'EB03' || prest.destino === 'EB04' || prest.destino === 'ERM' || prest.destino === 'LPGD')
              this.prestamosSelect = prestFilter
              break
            case 'TPA':
              prestFilter = this.prestamos.filter( (prest) => prest.destino === 'TPA')
              this.prestamosSelect = prestFilter
              break
            case 'CORP':
              prestFilter = this.prestamos.filter( (prest) => prest.destino === 'CORP')
              this.prestamosSelect = prestFilter
              break
            case 'IRGE':
              prestFilter = this.prestamos.filter( (prest) => prest.destino === 'IRGE')
              this.prestamosSelect = prestFilter
              break
            default:
              this.prestamosSelect = this.prestamos
              break
          }
        }
      } else {
        console.log('filter vacio')
        this.prestamosSelect = this.prestamos
      }
    },

    query_articulos() {
      const QUERY_ARTICULOS = this.query_articulos.toUpperCase()
      if (this.query_articulos !== '') {
        const prestFilter = this.prestamos.filter( asigns => { 
          return `${asigns.serie} ${asigns.recibe} ${asigns.ubicacion_Asig} ${asigns.entrega}`.toUpperCase().includes(QUERY_ARTICULOS)
        }) 
        this.prestamosSelect = prestFilter
        this.result_query = this.prestamosSelect.length === 1 ? `Se encontró ${this.prestamosSelect.length} coincidencia.` : `Se encontraron ${this.prestamosSelect.length} coincidencias.`
      } else {
        this.prestamosSelect = this.prestamos
        this.result_query = ''
      }
    }
  },
  methods: {
    iniciarComponente() {
      if (this.userLogin.cargo ==='331' || this.userLogin.cargo ==='332' || this.userLogin.cargo ==='323' || this.userLogin.cargo === '000' || this.userLogin.cargo === '003' || this.userLogin.cargo === '230' || this.userLogin.cargo === '210' || this.userLogin.cargo === '002' || this.userLogin.cargo === '2100' || this.userLogin.cargo === '321' || this.userLogin.cargo === '324')  {
        this.verFirmar = true
        if (this.areaAsignacion === '') {
          this.userNormal = false
        } else {
          this.verArticulosArea = true
        }
      } else {
        if (this.userLogin.cargo === '241' || this.userLogin.cargo === '242') {
          this.verArticulosArea = true
        } else {
          this.verArticulosArea = false
        }
        this.userNormal = true
      }
      
    },

    obtenerDataPrestamos () {

      if (!this.userNormal) {

        if (this.verArticulosArea) {
          let areaInt = 0
          switch (this.areaAsignacion) {
            case 'i':
              areaInt = 1
              break
            case 's':
              areaInt = 3
              break
            case 'a':
              areaInt = 2
              break
          }
          console.log(areaInt)
          InventarioServices.getPrestamosArea(areaInt)
            .then((data) => {
              this.prestamos = data.map(this.convertirPrest)
              this.prestamosSelect = this.prestamos
              this.checkHayDatos()
            })
            .catch((e) => {
              this.isLoading = false
              console.error(`Error: ${e.message}`)
            })
        } else {
          InventarioServices.getPrestamos('ALL', this.userLogin.cargo)
            .then(res => {
              this.prestamos = res.map(this.convertirPrest)
              this.prestamosSelect = this.prestamos
              this.checkHayDatos()
            })
            .catch((e) => {
              this.isLoading = false
            })
        }
        this.isLoading = false
      } else {

        if (this.verArticulosArea) {
          InventarioServices.getPrestamos(this.userLogin.ubicacion, this.userLogin.cargo)
            .then((data) => {
              this.prestamos = data.map(this.convertirPrest)
              this.prestamosSelect = this.prestamos
              this.checkHayDatos()
            })
            .catch((e) => {
              this.isLoading = false
              console.error(`Error: ${e.message}`)
            })
        } else {
          InventarioServices.getPrestamos_User(this.userLogin.id)
            .then((data) => {
              this.prestamos = data.map(this.convertirPrest)
              this.prestamosSelect = this.prestamos
              this.checkHayDatos()
            })
            .catch((e) => {
              this.isLoading = false
              console.error(`Error: ${e.message}`)
            })
        }
        this.isLoading = false
      }
    },

    convertirPrest (prest) {
      return {
        ...prest,
        id: parseInt(prest.id),
        id_prestamo: parseInt(prest.id_prestamo),
        area: parseInt(prest.area),
        estado: parseInt(prest.estado)
      }
    },

    checkHayDatos() {
      if (this.prestamosSelect.length > 0) {
        this.hayDatos = true
      } else {
        this.hayDatos = false
      }
      
    },

    irPrestamoDetalle (data) {
      if (this.userLogin.departamento == 1 || this.userLogin.departamento == 3 || this.userLogin.departamento == 6) {
        this.$store.commit('detallePrestamo', data)
        this.$router.push('/Inventario/Prestamos/Detalle')
      }
    },

    irResguardos (id) {
      this.$router.push({ path: `/Inventario/Resguardos/${id}` })
    },

    descargarResguardos () {
      let currentUrl = window.location.hostname

      if (!this.userNormal) {
        let areaInt
        switch (this.areaAsignacion) {
          case 'i':
            areaInt = 1
            break
          case 's':
            areaInt = 3
            break
          case 'a':
            areaInt = 2
            break
        
          default:
            areaInt = 0
            break
        }

        InventarioServices.createExcel_Resguardos(this.query, this.userLogin.cargo, areaInt)
          .then( res => {
            console.log(res)
            if (res.success) {
              open(`https://${currentUrl}/reportesApp/server/excel/generarResguardo_All.php?nameFile=${res.file}`, '_blank')
              setTimeout(() => {
                InventarioServices.borrarFile_InventarioUser(res.file)
                  .then( resDel => {
                    console.log(resDel)
                  })
              }, 4000)
            } else {
              console.log(res.respuesta)
            }
          })
          .catch((e=> {
            this.isLoading = false
            this.displayToast(e.message, 'ban', 'OK')
          }))
      } else {
        if (this.verArticulosArea) {
          this.descargarResguardoArea()
        } else {
          this.descargarResguardoIndvidual()
        }
      }

    },

    descargarResguardoArea () {
      let currentUrl = window.location.hostname
      InventarioServices.createExcel_Resguardos(this.userLogin.ubicacion, this.userLogin.cargo)
        .then( res => {
          console.log(res)
          if (res.success) {
            open(`https://${currentUrl}/reportesApp/server/excel/generarResguardo_All.php?nameFile=${res.file}`, '_blank')
            setTimeout(() => {
              InventarioServices.borrarFile_InventarioUser(res.file)
                .then( resDel => {
                  console.log(resDel)
                })
            }, 4000)
          } else {
            console.log(res.respuesta)
          }
        })
        .catch((e=> {
          this.isLoading = false
          this.displayToast(e.message, 'ban', 'OK')
        }))
    },

    descargarResguardoIndvidual () {
      let currentUrl = window.location.hostname
      
      InventarioServices.createExcel_Resguardo_Usuario(this.userLogin.id, this.userLogin.nombre,this.userLogin.nombre_file)
        .then( res => {
          if (res.success) {
            open(`https://${currentUrl}/reportesApp/server/excel/generarResguardo_User.php?nameFile=${res.file}`, '_blank');
            setTimeout(() => {
              InventarioServices.borrarFile_ResguardoUser(res.file)
                .then( resDel => {
                  console.log(resDel)
                })
            }, 4000)
          } else {
            console.log(res.respuesta)
          }
        })
    },

    getArea (asig) {
      let texto = ''
      
      switch (asig.area) {
        case '1':
          texto = `<span class="tag is-light">📟 Instrum./Control</span>`
          break
        case '3':
          texto = `<span class="tag is-light">💻 Sistemas y Telec.</span>`
          break
      }
      return texto
    },

    firmar(data, firma) {
      data['firma'] = firma
      if (this.userLogin.id === data.id_entrega) {
        this.firmarPrestamo(data, firma)
      }
    },

    firmarPrestamo(prest, firma) {
      this.isLoading = false
      console.log(prest)
      let myObjPrestamo = {
        id: prest.id,
        id_prestamo: prest.id_prestamo,
        clavePrestamo: prest.clavePrestamo,
        fechaReg: prest.fechaReg,
        fecha_entrega: prest.fecha_entrega,
        fecha_recibe: prest.fecha_recibe,
        id_entrega: prest.id_entrega,
        entrega: prest.entrega,
        id_recibe: prest.id_recibe,
        recibe: prest.recibe,
        area: prest.area,
        origen: prest.origen,
        ubicacion: prest.destino,
        ubicacion_ofi: prest.oficina_Asig,
        estado: prest.estado,
        firma_entrega: prest.firma_entrega,
        firma_recibe: prest.firma_recibe,
        hash: prest.hash,
        firma: firma

      }
      this.$store.commit('firmarPrestamo', myObjPrestamo)
      this.$router.push('/Inventario/Prestamos/Firma')
    },

    verHistoria (id) {
      this.$router.push({ path: `/Inventario/Historia/${id}` } )
    },

    backPage () {
      this.$router.back()
    },

    cambiarUbicacion(item) {
      if (this.userLogin.departamento === 3 || this.userLogin.departamento === 1  || this.userLogin.cargo === "321" || this.userLogin.cargo === "323" || this.userLogin.cargo ==='324') {
        this.itemCambiar = item
        this.configModal = {
          title: 'Reingresar',
          content: `¿Desea reingresar el artículo al almacén?`,
          textCancel: 'Cancelar',
          textOk: 'Guardar'
        }
        this.modalStatus = true
      }
    },

    selectNewOffice (result) {
      if (result === 'close') {
        this.modalStatus = false
        return
      }
      this.isLoading = true
      if ( Object.keys(result).length > 0 ) {
        if (result.estatus != 12) {
          let id = Date.now()
          let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
          const ubi = result.ubicacion ? result.ubicacion : this.itemCambiar.ubicacionArt
          const ofi = result.oficina ? result.oficina : this.itemCambiar.oficinaArt

          let idEntrega = ''
          let entrega = ''
          let idRecibe = ''
          let recibe = ''
          switch (result.estatus) {
            case 6:
              idEntrega = this.itemCambiar.i_recibe
              entrega = this.itemCambiar.recibe
              idRecibe = result.idUserAlmacen
              recibe = result.userAlmacen
              break
            case 7:
              idEntrega = this.itemCambiar.i_recibe
              entrega = this.itemCambiar.recibe
              idRecibe = this.itemCambiar.i_recibe
              recibe = this.itemCambiar.recibe
              break
            case 8:
              idEntrega = this.itemCambiar.i_recibe
              entrega = this.itemCambiar.recibe
              idRecibe = result.idUserAlmacen
              recibe = result.userAlmacen
              break
            case 9:
              idEntrega = this.itemCambiar.i_recibe
              entrega = this.itemCambiar.recibe
              idRecibe = result.idUserAlmacen
              recibe = result.userAlmacen
              break
            case 10:
              idEntrega = this.itemCambiar.i_recibe
              entrega = this.itemCambiar.recibe
              idRecibe = result.idUserAlmacen
              recibe = result.userAlmacen
              break
            case 11:
              idEntrega = '1538165924968'
              entrega = 'Administrador'
              idRecibe = this.itemCambiar.i_recibe
              recibe = this.itemCambiar.recibe
            case 12:
              idEntrega = '1538165924968'
              entrega = 'Administrador'
              idRecibe = result.idUserAlmacen
              recibe = result.userAlmacen
              break
          }
          
          InventarioServices.addUbicacion(id, this.itemCambiar.id_articulo, fechaReg, ubi, ofi, 
          idEntrega, entrega, idRecibe, recibe, result.estatus)
            .then((data) => {
                this.obtenerDataPrestamos()
                this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'OK')
            })
            .catch((e) => {
              this.isLoading = false
              this.displayToast('bubble',e.message, 'ban', 'OK')
            })
        } else {
          this.isLoading = false
          this.$store.commit('bajaArticulo', this.itemCambiar.id)
          this.$router.push('/Inventario/Almacen/Bajas/Nueva')
        }

      }
      this.modalStatus = false
    },

    verModalD (data) {
      this.prestamoToModal = data
      this.modalStatusD = true
    },

    cerrarModalD () {
      this.prestamoToModal = {}
      this.modalStatusD = false
    },

    displayToast(text, icon, actionText) {
      let toast = this.$toasted.show(text, { 
        theme: "toasted-primary", 
        position: "bottom-right", 
        duration : null,
        iconPack: 'fontawesome',
        icon: icon,
        action : {
          text : actionText,
          onClick : (e, toastObject) => {
            toastObject.goAway(0)
          }
        },
      })
    },
    
    updateUbicacion (data) {
      console.log(data)
      if (data.success) {
        this.displayToast(data.repsuesta, 'done', 'OK')
        this.obtenerDataPrestamos()
      } else {
        this.displayToast(data.repsuesta, 'ban', 'OK')
      }
    },

    subirDocumento (docto) {
      this.modalStatusD = false
      this.isLoading = true
      if (docto) {
        const nombreFile = docto.name
        InventarioServices.uploadDocumento(this.prestamoToModal.id_articulo, nombreFile, docto)
          .then(data => {
            this.obtenerDataPrestamos()
            this.displayToast(data.respuesta, data.success ? 'done' : 'ban', 'Ok')
          })
          .catch( error => {
            this.isLoading = false
            this.displayToast(`Error: ${error.message}`, 'ban', 'Ok')
          })
      } else {
        this.displayToast(docto, 'ban', 'OK')
        this.isLoading = false
      }
      
    },
    
    borrarDocumento (docto) {
      this.modalStatusD = false
      this.isLoading = true
      if (docto) {
        InventarioServices.deleteDocumento(docto.id, docto.ruta)
          .then(data => {
            this.obtenerDataPrestamos()
            this.displayToast(data.respuesta, data.success ? 'done' : 'ban', 'Ok')
          })
          .catch( error => {
            this.isLoading = false
            this.displayToast(`Error: ${error.message}`, 'ban', 'Ok')
          })
      }
    },
    
    getRuta (ruta) {
      const currentURL = window.location.hostname
      return `https://${currentURL}${ruta}`
    },

    printReporte (data) {
      let currentUrl = window.location.hostname
      let tipo = 'pdf'
      let link = `https://${currentUrl}/servidores/reportes/inventarios/prestamoI.php?id=${data.id_prestamo}&cp=${data.clavePrestamo}`
      open(link)
    },
    irSalidas(tipo) {
      this.$store.commit('selectSalida', tipo)
      this.$router.push( {path: '/Inventario/Busqueda'})
    },
    obtenerAlmacenes() {
      InventarioServices.getAlmacenesConsumibles('c')
        .then( data => {
          this.almacenes = data.map(this.convertirAlmacenes)
          this.obtenerAlmacenOrigen()
        })
        .catch((e) => {
          this.isLoading = false
          this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
        })
    },
    convertirAlmacenes (ofi) {
      return {
        ...ofi,
        id: parseInt(ofi.id),
        id_ubicacion: parseInt(ofi.id_ubicacion),
        id_oficina: parseInt(ofi.id_oficina),
        inventario: parseInt(ofi.inventario) == 1 ? true : false,
      }
    },
    obtenerAlmacenOrigen() {
      console.log(this.almacenes)
      this.almacenes.map( alm => {
        const encontrado = alm.almacenistas.find( a => a.id_usuario === this.userLogin.id)
        if (encontrado) {
          this.origen = alm
        }
      })
      console.log(this.origen)
      this.getSede()
    },
    getSede() {
      switch (this.origen.clave) {
        case 'TPA-ALS':
        this.title = 'Asignaciones de TPA GIA'
        this.sede = 'TPA'
        break
      case 'EB04-ALG':
        this.title = 'Asignaciones de EB04 GIA'
        this.sede = 'EB04'
        break
      case 'CORP-ALG':
        this.title = 'Asignaciones de Corporativo GIA'
        this.sede = 'CORP'
        break
      case 'IRGE-ALM':
        this.title = 'Asignaciones de IRGE'
        this.sede = 'IRGE'
        break
      case 'IRGE-ALA':
        this.title = 'Asignaciones de IRGE Activos'
        this.sede = 'IRGE'
        break
      case 'CORP-ALM':
        this.title = 'Asignaciones de Corporativo'
        this.sede = 'CORP'
        break
      case 'TPA-ALM':
        this.title = 'Asignaciones de TPA'
        this.sede = 'TPA'
        break
      case 'EB04-ALM':
        this.title = 'Asignaciones de EB04'
        this.sede = 'EB04'
        break
      case 'EB00-ALM':
        this.title = 'Asignaciones de EB00'
        this.sede = 'EB00'
        break
      case 'EB01-ALM':
        this.title = 'Asignaciones de EB01'
        this.sede = 'EB01'
        break
      case 'EB02-ALM':
        this.title = 'Asignaciones de EB02'
        this.sede = 'EB02'
        break
      case 'EB03-ALM':
        this.title = 'Asignaciones de EB03'
        this.sede = 'EB03'
        break
      case 'ERM-ALM':
        this.title = 'Asignaciones de ERM'
        this.sede = 'ERM'
        break
      }
      this.iniciarComponente()
    },
  },
  created () {
    switch (this.areaAsignacion) {
      case 'a':
        this.title = 'Inventario de equipos prestados de administración'
        break
      case 'i':
        this.title = 'Inventario de instrumentos prestados'
        break
      case 's':
        this.title = 'Inventario de equipos prestados Sistemas'
        break
    
      default:
        this.title = ''
        break;
    }
    console.log(this.almacenSelect)
    if (this.almacenSelect !=='' || this.almacenSelect === 'c') {
      this.obtenerAlmacenes()
    } else {
      this.iniciarComponente()
    }
  },
  computed: {
    ...mapState(['userLogin', 'areaAsignacion', 'almacenSelect', 'permisos'])
  },
  mounted() {
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.modalStatus = false // how to hide any open modal?
        this.modalStatusD = false
      }
    })
  }
}
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 150px;
  }

  .table-responsive {
    overflow-x: auto;
    margin: 10px auto;
  }
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/Prestamos.vue